import React from 'react';
import { COURSE_GUIDE_LABEL } from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';
/**
 * @desc Dictionaries of copy throughout application, by application domain.
 * @todo Refactor to JSON for use with i18n or other localization tools, move other copy here.
 */
const McqLabel = 'MC Question';
const FrqLabel = 'FR Question';
const PracticeLabel = 'Practice Exam';
export const QUESTION_BANK = {
  QUIZ_MAKER: {
    LABELS: {
      'media/rich_text': 'Passage',
      'questions/multiple_choice': McqLabel,
      'questions/free_response': FrqLabel,
      'secure_questions/multiple_choice': `${PracticeLabel} ${McqLabel}`,
      'secure_questions/free_response': `${PracticeLabel} ${FrqLabel}`,
    },
  },
};

export const UNITS = {
  ADMIN_COORDINATOR: {
    UNIT_NOTIFICATION:
      'Teachers can use AP Classroom to share units with their classes.',
    RESOURCE_NOTIFICATION:
      'Teachers can use AP Classroom to share instructional resources with their classes.',
    ASSIGN_NOTIFICATION:
      'Teachers can use AP Classroom to assign assessment resources to their classes.',
  },
  SHARE: {
    Unit: {
      LABEL: 'Share Unit',
      DESCRIPTION:
        'Choose one or many classes to see this unit. You can add or remove units at any time.',
    },
    URLResource: {
      LABEL: 'Share Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    EBookResource: {
      LABEL: 'Book Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    ProfessionalLearningLinkResource: {
      LABEL: 'Professional Learning Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    PartnerLinkResource: {
      LABEL: 'Partner Link Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    DistanceLinkResource: {
      LABEL: 'Share Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    SourceResource: {
      LABEL: 'Share Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    LTIResource: {
      LABEL: 'Share Resource',
      DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}. You can adjust which classes can see this resource at any time.`,
    },
    EmbeddedVideoResource: {
      LABEL: 'Assign Video',
      DESCRIPTION:
        'Assign this video to emphasize it on students’ AP Classroom homepage with a To-Do card.',
    },
  },
  ASSIGN: {
    MODAL_TITLE: (
      unitNumber,
      displayName = '',
      isPreApSubject = false,
      unitTitle = '',
    ) => {
      let text = isPreApSubject
        ? unitTitle
        : `Unit ${unitNumber}: Progress Check`;

      return displayName.includes(text.replace(':', ''))
        ? displayName
        : `${text} ${displayName}`;
    },
  },
};

export const ASSESSMENTS = {
  NOW_OPEN: 'Now Open',
  NO_CLASSES_YET: "It looks like you don't have any classes yet.",
  NO_CLASSES_YET_INFRA_ASSIGN:
    'Teachers can assign assessments to their classes.',
  NO_CLASSES_YET_INFRA_PROGRESS:
    'Teachers can monitor and score the assignments for their classes.',
  NO_CLASSES_YET_INFRA_RESULTS:
    'Teachers can see results of submitted assignments for their classes.',
  NO_ASSESSMENTS_CREATED: 'You have not created an assessment yet.',
  NO_ASSESSMENTS_FILTER:
    'No matching results. Remove filter selection(s) to see assessments.',
  TIMER_DESCRIPTION:
    'A timer with the limit you set will be shown to students once they start the assessment. When time’s up, students can continue working unless you manually lock the assessment.',
  START_DUE_DATE_DESCRIPTION:
    'Automatically unlock and lock this assessment across the date and time range entered below.',
  RESTRICTION_MESSAGE:
    'Questions can only be previewed once the assessment is in progress or has been submitted.',
};

export const GENERAL_COPY = {
  FILTERS: 'Filters',
  PREVIEW: 'Preview',
};

export const ERRORS = {
  PILOT_P2: {
    STUDENT_NOT_IN: {
      id: 0,
      header: 'AP Classroom Error',
      title:
        'The AP Registration and Ordering and AP Classroom systems are currently restricted to schools that are part of the 2018-19 AP or Pre-AP Implementation. If you are from a 2018-19 AP or Pre-AP Implementation school you need to make sure that you are enrolled in a section.',
      description:
        'If you are from a pilot school you need to make sure that you are enrolled in a section.',
    },
    STUDENT_ENROLLMENT_MISMATCH: {
      id: 1,
      header: 'AP Classroom Error',
      title: 'AP Classroom does not yet have you enrolled in this class.',
      description:
        'Please try again later, check with your Teacher or Coordinator, or use the Contact Us form under the Help menu',
    },
    STUDENT_EMPTY_ENROLLMENT: {
      id: 2,
      header: 'AP Classroom Error',
      title: 'AP Classroom does not have you enrolled in any classes.',
      description:
        'Please try again later or contact Customer Support from the Help menu.',
    },
    STUDENT_UNKNOWN: {
      id: 3,
      header: 'AP Classroom Error',
      title: 'There was a problem setting up your class resources.',
      description:
        'Please try again in a few minutes. If the problem persists, use the Contact Us form under the Help menu.',
    },
    GENERAL_UNKNOWN: {
      id: 4,
      header: 'AP Classroom Error',
      title: 'There was a problem setting up your AP Classroom resources.',
      description:
        'Please try again in a few minutes. If the problem persists, use the Contact Us form under the Help menu.',
    },
    // Not implemented SIGNIN, UNAUTHORIZED
    SIGNIN: {
      id: 5,
      header: 'AP Classroom Error',
      title: 'There was a problem signing you in to AP Classroom.',
      description:
        'Please try again in a few minutes. If the problem persists, use the Contact Us form under the Help menu.',
    },
    UNAUTHORIZED: {
      id: 6,
      header: 'AP Classroom Error',
      title: 'You are not authorized to view this page.',
      description:
        'If you think this is in error, please log out and try again, or contact support.',
    },
    TEACHER_NOT_IN: {
      id: 7,
      header: 'AP Classroom Error',
      title:
        'For you to use AP Classroom, your school must be given access.  Your school currently does not have access.  If you think this is in error, please contact your school Coordinator or College Board support.',
      description: '',
    },
    TEACHER_UNKNOWN: {
      id: 8,
      header: 'AP Classroom Error',
      title: 'AP Classroom is not receiving your Course Audit authorizations.',
      description:
        'Please try again in a few minutes. If the problem persists, contact your AP Coordinator or use the Contact Us form under the Help menu.',
    },
    ASSESSMENT_NOT_STARTED: {
      id: 9,
      header: 'AP Classroom Error',
      title: 'AP Classroom has not unlocked this assessment',
      description:
        'This assessment has yet to begin. Please contact your teacher to find out when this assessment starts.',
    },
    TEACHER_PREAP_ORDER: {
      id: 10,
      header: 'Pre-AP Classroom Error',
      title: 'You no longer have access to Pre-AP Classroom',
      description: (
        <p>
          In order to restore your access, please{' '}
          <a href="https://order.collegeboard.org/preap">
            order Pre-AP for the 2022-23 academic year
          </a>
          .
        </p>
      ),
    },
  },
  PILOT_1I: {
    STUDENT_NOT_IN: {
      id: 0,
      header: 'AP Classroom Error',
      title:
        'The AP Registration and Ordering Management Pilot, which includes AP Classroom, is currently restricted to schools which are participating in this pilot.',
      description:
        'If you are from a pilot school you need to make sure that you are enrolled in a section.',
    },
    STUDENT_ENROLLMENT_MISMATCH: {
      id: 1,
      header: 'AP Classroom Error',
      title: 'AP Classroom does not yet have you enrolled in this class.',
      description:
        'Please try again later, check with your Teacher or Coordinator, or use the Contact Us form under the Help menu',
    },
    STUDENT_EMPTY_ENROLLMENT: {
      id: 2,
      header: 'AP Classroom Error',
      title: 'AP Classroom does not have you enrolled in any classes.',
      description:
        'Please try again later or contact Customer Support from the Help menu.',
    },
    STUDENT_UNKNOWN: {
      id: 3,
      header: 'AP Classroom Error',
      title: 'There was a problem setting up your class resources.',
      description:
        'Please try again in a few minutes. If the problem persists, use the Contact Us form under the Help menu.',
    },
    GENERAL_UNKNOWN: {
      id: 4,
      header: 'AP Classroom Error',
      title: 'There was a problem setting up your AP Classroom resources.',
      description:
        'Please try again in a few minutes. If the problem persists, use the Contact Us form under the Help menu.',
    },
    // Not implemented SIGNIN, UNAUTHORIZED
    SIGNIN: {
      id: 5,
      header: 'AP Classroom Error',
      title: 'There was a problem signing you in to AP Classroom.',
      description:
        'Please try again in a few minutes. If the problem persists, use the Contact Us form under the Help menu.',
    },
    UNAUTHORIZED: {
      id: 6,
      header: 'AP Classroom Error',
      title: 'You are not authorized to view this page.',
      description:
        'If you think this is in error, please log out and try again, or contact support.',
    },
    TEACHER_NOT_IN: {
      id: 7,
      header: 'AP Classroom Error',
      title:
        'The AP Registration and Ordering Management Pilot, which includes AP Classroom, is currently restricted to schools which are participating in this pilot.',
      description: '',
    },
    TEACHER_UNKNOWN: {
      id: 8,
      header: 'AP Classroom Error',
      title: 'AP Classroom is not receiving your Course Audit authorizations.',
      description:
        'Please try again in a few minutes. If the problem persists, contact your AP Coordinator or use the Contact Us form under the Help menu.',
    },
    TEACHER_PREAP_ORDER: {
      id: 10,
      header: 'Pre-AP Classroom Error',
      title: 'You no longer have access to Pre-AP Classroom',
      description: (
        <p>
          In order to restore your access, please{' '}
          <a href="https://order.collegeboard.org/preap">
            order Pre-AP for the 2022-23 academic year
          </a>
          .
        </p>
      ),
    },
  },
  GENERAL: {
    ASSESMENT_NOTFOUND: {
      id: 7,
      header: 'Assessment is not available.',
      title:
        'You are trying to access an assessment that either could not be found or you don’t have access to.',
      /*
       * TBD: 1) update ft-cb propTypes of alertBox to have string OR object.
       * 2) Re-think the way of how we can place links here.
       */
      description: (
        <span>
          Please contact your teacher to verify if the assessment exists and is
          accessible or contact technical support at
          <a href="mailto:support-apc@academicmerit.com">
            {' '}
            support-apc@academicmerit.com{' '}
          </a>
        </span>
      ),
    },
  },
};

export const ADMIN_UNIT_OUTLINE = {
  MCQ_ALERT: `This dynamic icon appears if students have results on this assessment.
    Teachers can see student results or progress completing this assessment for every class.`,
  FRQ_ALERT: `This dynamic icon appears if teachers assign this assessment.
    Teachers can see student progress completing this assessment for every class.`,
  SHARE_RESOURCE_ALERT: `Teachers decide which resources students will see in their AP Classroom ${COURSE_GUIDE_LABEL} by selecting 1 or more classes here.`,
  SHARE_VIDEO_RESOURCE_ALERT:
    'Teachers are able to assign videos to class sections. Assigning a video creates a To-Do card on student homepages linking to this video. This assignment can be modified at any time.',
  PE_FRQ: `These dynamic bars appear if students have results on this assessment. Teachers can see student results or progress completing this assessment for every class, or assign it to others.`,
};

export const ANSWER_SHEETS = {
  ISSUE: {
    POPOVER:
      "The answer sheet may have issues preventing it from being processed.  Inspect the student's submitted answer sheet. Any markings, glare, or shadows that obscure the multiple choice bubbles, borders of the answer sheet, or codes at the bottom can cause this to happen. A corrected answer sheet can be re-uploaded. Refreshing the assignment page ensures you see the latest status.",
  },
};

export const getConfirmationMessage = (expirationTimeDiff, assignmentTimer) => {
  return `<strong> Your AP Classroom session will expire in ${expirationTimeDiff} minutes, but you have ${assignmentTimer} minutes to complete the assessment.</strong> To prevent being signed out, please re-enter your password. Once you do so, you'll return here with a new 2 hour session.`;
};

export const RESOURCES = {
  NO_CLASSES_ALERT: {
    LABEL: 'Create a class section in order to share this resource.',
    DESCRIPTION: `Select who should see this resource in their AP Classroom ${COURSE_GUIDE_LABEL}.`,
  },
};
